import React from 'react';
import './i18n';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ScrollToTop } from './components/ScrollToTop';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { HomePage } from './pages/HomePage';
import { HotelDetailsPage } from './pages/HotelDetailsPage';
import { MyBookingsPage } from './pages/MyBookingsPage';
import { HotelDashboard } from './pages/HotelDashboard';
import { AdminDashboard } from './pages/AdminDashboard';
import { ProfilePage } from './pages/ProfilePage';
import { LiinkShoppingPage } from './pages/LiinkShoppingPage';
import { ListYourPropertyPage } from './pages/ListYourPropertyPage';
import { StaffTrainingProgrammePage, SkillDevelopmentProgrammePage, LiinkCertificationPage } from './pages/ProgrammePage';
import { InsightsPage } from './pages/InsightsPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { StaticPageRouteList } from './components/staticPagesConfig';
import '@/App.css';

const GUEST_ROLES = ['guest'];
const GUEST_OR_HOTEL_ROLES = ['guest', 'hotel'];
const HOTEL_ROLES = ['hotel'];
const ADMIN_ROLES = ['admin'];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/list-your-property" element={<ListYourPropertyPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/staff-training-programme" element={<StaffTrainingProgrammePage />} />
            <Route path="/skill-development-programme" element={<SkillDevelopmentProgrammePage />} />
            <Route path="/liink-certification" element={<LiinkCertificationPage />} />
            <Route path="/hotels/:hotelId" element={<HotelDetailsPage />} />
            <Route
              path="/my-bookings"
              element={
                <ProtectedRoute allowedRoles={GUEST_ROLES}>
                  <MyBookingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute allowedRoles={GUEST_OR_HOTEL_ROLES}>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route path="/liink-shopping" element={<LiinkShoppingPage />} />
            {StaticPageRouteList().map((p) => (
              <Route key={p.path} path={p.path} element={p.element} />
            ))}
            <Route
              path="/hotel/dashboard"
              element={
                <ProtectedRoute allowedRoles={HOTEL_ROLES}>
                  <HotelDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
